import React from "react"
import { createRoot } from "react-dom/client"
import App from "./app/App"

const rootElement = document.getElementById("root")
const root = createRoot(rootElement)
root.render(<App basePath={rootElement.dataset?.basepath} />)

// Note: If the root contains a `data-basePath` attribute, that
// path is used as the `basename` property in the react-router BrowserRouter,
// to support serving from different directory paths.
